export default __webpack_public_path__ + "static/media/custom1.32b73f19.jpg";